import { render, staticRenderFns } from "./dropdown_footer.vue?vue&type=template&id=6403c799&"
import script from "./dropdown_footer.vue?vue&type=script&lang=js&"
export * from "./dropdown_footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports